export default {"src":"/_next/static/media/client-09.1b3cdb83.svg","height":28,"width":92,"blurWidth":0,"blurHeight":0};